angular.module('invoice')
    .controller('InvoiceCostTypeDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, InvoiceCostType) {
        this.$onInit = () => {
            this.item = data;
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = InvoiceCostType.update(this.item).$promise
            } else {
                promise = InvoiceCostType.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast('invoice-cost-type.updated')
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
